import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Coins, GraduationCap, Award, FileText } from 'lucide-react';
import SEO from '../components/SEO';
import { PageHero, FeatureGrid, ProseSection, CTABand } from '../components/marketing';

const HELP = [
  { Icon: Coins, title: 'Government aid', desc: 'OSAP, Canada Student Loan, Pell Grant. Eligibility check, form filing, follow-up.' },
  { Icon: GraduationCap, title: 'College scholarships', desc: 'Merit, need-based and demographic-specific. We track 1,200+ scholarships and match you.' },
  { Icon: Award, title: 'External grants', desc: 'Industry, alumni, private foundation. We help with essays and submission deadlines.' },
  { Icon: FileText, title: 'Private financing', desc: 'Education loans, lines of credit, parent co-sign options — with real interest-rate comparisons.' },
];

export default function StudentAidPage() {
  return (
    <div className="bg-tge-paper min-h-screen">
      <SEO title="Financial Assistance — True Global Education" />
      <PageHero
        eyebrow="Financial assistance"
        title="Don't leave money on the table."
        intro="The average student misses $9,400 in aid they were eligible for, simply because they didn't apply. Let's make sure that's not you."
      />
      <FeatureGrid items={HELP} columns={2} />
      <ProseSection eyebrow="What we deliver" title="Aid maximization in 5 working days.">
        <p>
          We start with an eligibility audit (free), then build a prioritized list of every grant, loan and
          scholarship you qualify for — ranked by award size and acceptance odds. Then we help you fill out
          the forms. Most clients see between $5,000 and $20,000 in additional approved aid.
        </p>
      </ProseSection>
      <CTABand
        title="Run your aid audit"
        body="Free, no commitment. You'll know exactly what you're eligible for in under a week."
        primary={
          <Link
            to="/contact"
            className="bg-tge-gold hover:bg-tge-gold-soft text-tge-navy font-semibold px-7 py-3.5 rounded-full inline-flex items-center gap-2 transition"
          >
            Start audit <ArrowRight size={17} />
          </Link>
        }
      />
    </div>
  );
}
